import type { ControlFormProps } from '@ingenico/react-section-utils';
import type { IStepProps } from '@ingenico/react-ui/content-stepper';
import type { StepperApi } from '@ingenico/react-ui/stepper';
import type { MutableRefObject } from 'react';
import type { FieldPath, UseFormReturn } from 'react-hook-form';
import type { TFunction } from 'react-i18next';
import type { ArtifactResource } from '../../domain/models/artifact.model';
import type { TemplateResponseResourceFront } from '../../domain/models/template.model';
import type {
  AppVersionApplicationFile,
  SystemPackageAppVersion,
} from '../../pages/create-system-package-version-page/createSystemPackageVersionPage.model';
import type { ApplicationVersionDefinitionWithOptions } from '../system-package-version-definition-step/systemPackageVersionDefinitionStep.model';

export interface DeviceApplicationVersionStepsVMOutput {
  readonly formMethods: UseFormReturn<SystemPackageAppVersion>;
  readonly isLoading?: boolean;
  readonly stepperRef: MutableRefObject<StepperApi | null>;
  readonly steps: IStepProps[];
  readonly shouldShowConfirmationDialog: boolean;
  readonly isSendingAppVersion: boolean;
  readonly handleSendAppVersion: () => void;
  readonly t: TFunction;
  readonly handleCancelConfirmationDialog: () => void;
  readonly isLoadingCreation?: boolean;
}

export interface UseSystemPackageVersionAppStepsParams {
  readonly moveToNextStep?: (stepKey: AppVersionStepsKeys) => void;
  readonly moveToPreviousStep?: (stepKey?: AppVersionStepsKeys) => void;
  readonly control: ControlFormProps<SystemPackageAppVersion>['control'];
  readonly validateNextIsDisabled?: (stepKey?: AppVersionStepsKeys) => boolean;
  readonly applicationFiles?: AppVersionApplicationFile[];
  readonly existingTemplates?: AppVersionApplicationFile[];
  readonly setFieldError?: (fieldPath: FieldPath<SystemPackageAppVersion>, message: string) => void;
  readonly clearFieldError?: (fieldPath: FieldPath<SystemPackageAppVersion>) => void;
  readonly definitionOptions?: ApplicationVersionDefinitionWithOptions;
  readonly onClickCancel?: () => void;
  readonly hasPartialFileUpdateError?: boolean;
  readonly isLoadingTemplateResources?: boolean;
  readonly shouldEnableDownloadRules?: boolean;
  readonly triggerDeploymentRulesValidation?: () => void;
}
export interface UseAppVersionStepsReturn {
  readonly steps: IStepProps[];
}

export interface UseSystemPackageVersionStepsParams {
  readonly redirectRouteOnCreate?: string;
  readonly parentEntityId?: string;
  readonly t: TFunction;
}

export enum AppVersionStepsKeys {
  Define = 'define',
  Build = 'build',
  Configure = 'configure',
  Summary = 'summary',
  DeploymentRules = 'deploymentRules',
}

export type UploadedFileResponseInfo = {
  readonly targetLocation?: string;
  readonly uploadId?: string;
} & (ArtifactResource | TemplateResponseResourceFront);

export enum SystemPackageVersionFormError {
  NoEmptyNamesInDeploymentRules = 'no-empty-names-in-deployment-rules',
}
